module.exports = "/_next/static/images/background-d7eb1912562fc788f2dc6533eda96410.png";